/**
 * Socket event names used across the agent dashboard and visitor microservice.
 * Keep in sync with server emits (e.g. chatapp-visitor-microservice, agent service).
 */
export const SOCKET_EVENTS = {
  /** Server pushes when session is invalidated (login elsewhere or expired). */
  SESSION_EXPIRED: "sessionExpired",
  /** Fan-out to all sockets in the brand (websiteToken) so agents see the thread without joining the visitor room. */
  VISITOR_CHAT_TO_BRAND: "visitorChatToBrand",
  /** Admin blocks/unblocks an agent — relayed by the server to the target user and team. */
  ADMIN_BLOCKED_USER: "adminBlockedUser",
  /** Server broadcast when an agent account is blocked or unblocked. */
  USER_BLOCKED: "UserBlocked",
};
